module.exports = __webpack_public_path__ + "img/horizontal_6_7_6000.c6400905.png";